import React, { createContext, useEffect, useRef, useState } from 'react'
import MyRadioPhoneScreen from '../MyRadioPhoneScreen';
import FacebookPhoneScreen from '../FacebookPhoneScreen';
import BlogPhoneScreen from '../BlogPhoneScreen';
import AlarmPhoneScreen from '../AlarmPhoneScreen';
import DedicationPhoneScreen from '../DedicationPhoneScreen';
import WebsitePhoneScreen from '../WebsitePhoneScreen';
import RSSPhoneScreen from '../RSSPhoneScreen';
import HtmlPhoneScreen from '../HtmlPhoneScreen';
import AudioShoutOutPhoneScreen from '../AudioShoutOutPhoneScreen';
import LiveFeedPhoneScreen from '../LiveFeedPhoneScreen';
import VideoPhoneScreen from '../VideoPhoneScreen';
import PodcastPhoneScreen from '../PodcastPhoneScreen';
export const MyMobileContext = createContext();
export const MyMobileContextProvider = ({ children }) => {
    const [token, setToken] = useState(null);
    const [preview, setPreview] = useState(null)
    const [previews, setPreviews] = useState(null)
    const [previewss, setPreviewss] = useState(null)
    const [menuPreviews, setMenuPreviews] = useState(null)
    const [buttonValue,setButtonValue] = useState(null);
    const [allApps,setAllApps] = useState([])
    const [myTextColor, setMytextColor] = useState("#ffffff")
    const [myMenuBGColor, setMyMenuBGColor] = useState("#ffffff")
    const [myMenuTextColor, setMyMenuTextColor] = useState("#343236")
    const [MyBGColor, setMyBGColor] = useState("#9682aa")
    const [MyBGGradientColor, setMyBGGradientColor] = useState("#8c55d4")
    const [selectedColorTextId, setSelectedColorTextId] = useState(null);
    const [myLanguage, setMyLanguage] = useState("en")
    const [bgOpacity, setBGOpacity] = useState("100")
    const [buttonActive, setButtonActive] = useState("vector3")
    const [ShadowActive, setShadowActive] = useState("rectangleShadow1")
    const [textAlignSetting, setTextAlignSetting] = useState("left")
    const [bgGradientOpacity, setBGgradientOpacity] = useState("100")
    const [BGGradientColorId, setBgGradientColorId] = useState(null);
    const [BGColorId, setBgColorId] = useState(null);
    const [value, setValue] = useState(40)
    const [blur, setBlur] = useState(true)
    const [blurCover, setBlurCover] = useState(true)
    const [font, setFont] = useState("monospace")
    const [textAndfont, setTextAndFont] = useState("18.2647px")
    const [backgroundType, setBackgroundType] = useState("color")
    const [BGColorTo, setBGColorTo] = useState("solid")
    const [BGColorDirection, setBGColorDirection] = useState("down")
    const [BGBIColorDirection, setBGBIColorDirection] = useState("down")
    const [myRadioActive,setMyRadioActive] = useState("isActiveRoundedRectangle")
    const [myRadioBorderOpacity,setMyRadioBorderOpacity] = useState("100")
    const [myGeneralButtonOpacity,setMyGeneralButtonOpacity] = useState("100")
    const [myGeneralBTNColor,setMyGeneralBTNColor] = useState("#9682aa");
    const [myFacebookDesignColor,setMyFacebookDesignColor] = useState("#FFF");
    const [myVideoDesignColor,setMyVideoDesignColor] = useState("#FFF");
    const [myHTMLDesignColor,setMyHTMLDesignColor ] = useState("#FFF");
    const [mywbsiteDesignColor,setMywbsiteDesignColor] = useState("#FFF");
    const [myAlarmClockDesignColor,setMyAlarmClockDesignColor] = useState("#FFF");
    const [myPodcastDesignColor,setMyPodcastDesignColor] = useState("#FFF");
    const [myRSSDesignColor,setMyRSSDesignColor] = useState("#FFF");
    const [myDedicationDesignColor,setMyDedicationDesignColor] = useState("#FFF");
    const [myAudioShoutOutDesignColor,setMyAudioShoutOutDesignColor] = useState("#FFF");
    const [myBlogDesignColor,setMyBlogDesignColor] = useState("#FFF");
    const [BTNType,setBTNType] = useState(true)
    const [myRadioBorderColor,setMyRadioBorderColor] = useState("#fff");
    const [myBorderRadious,setMyBorderRadious] = useState("0px");
    const [MyGeneralButtonColorId, setMyGeneralButtonColorId] = useState(null);
    const [myVideoDesignColorId,setMyVideoDesignColorId] = useState(null);
    const [mywbsiteDesignColorId,setMywbsiteDesignColorId] = useState(null);
    const [myPodcastDesignColorId,setMyPodcastDesignColorId] = useState(null);
    const [myDedicationDesignColorId,setMyDedicationDesignColorId] = useState(null);
    const [myAudioShoutOutDesignColorId,setMyAudioShoutOutDesignColorId] = useState(null);
    const [myRSSDesignColorId,setMyRSSDesignColorId] = useState(null);
    const [myFacebookDesignColorId,setMyFacebookDesignColorId] = useState(null);
    const [myAlarmClockDesignColorId,setMyAlarmClockDesignColorId] = useState(null);
    const [myBlogDesignColorId,setMyBlogDesignColorId] = useState(null);
    const [myRadioselectedColorId, setMyRadioSelectedColorId] = useState(null);
    const [myRadioArtistColor, setMyRadioArtistColor] = useState(null);
    const [myRadioSelectedBGColorId, setMyRadioSelectedBGColorId] = useState(null);
    const [myRadioSelectedColorTextId, setMyRadioSelectedColorTextId] = useState(null);
    const [myMenuBGColorTextId, setMyMenuBGColorTextId] = useState(null);
    const [myHTMLDesignColorId,setMyHTMLDesignColorId] = useState(null);
    const [myMenuTextId, setMyMenuTextId] = useState(null);
    const [myRadioBackgroundOpacity, setMyRadioBackgroundOpacity] = useState("70");
    const [myRadioBackgroundColor,setMyRadioBackgroundColor] = useState("#ffffff25")
    const [myRadioTextColor,setMyRadiotextColor] = useState("#ffffff")
    const [showPopup, setShowPopup] = useState(false);
    const [bodySize,setBodySize] = useState("without margin")
    const [dark, setDark] = useState(false)
    const MyBorderRef = useRef(null);
    const MyLikeRef = useRef(null);
    const MyBGColorChgRef = useRef(null);
    const GeneralTextRef = useRef(null);
    const [showLogoBorder,setShowLogoBorder] = useState(false)
    const sideBarToggleRef = useRef(null);
    const [toggleClass, setToggleClass] = useState(null)
        const [appIconPreviews, setAppIconPreviews] = useState(null)
        const [smartPhoneLargePreviews, setSmartPhoneLargePreviews] = useState(null)
        const [smartPhonePreviews, setSmartPhonePreviews] = useState(null)
        const [appName,setAppName] = useState("");
        const [shortDescription,setShortDescription] = useState("");
        const [longDescription,setLongDescription] = useState("");
    // const [DropdownVisibleFor, setDropdownVisibleFor] = useState(null);
    const [designChange, setDesignChange] = useState({
        "showCoverBorder": true,
        "My-Radio-Border-color-opacitys": "100",
        "My-Radio-Border-Hexa-code": "#fff"

    })

    const [allOptions, setAllOptions] = useState(
        {
            CallOption: false,
            SMSOption: false,
            ShareOption: true,
            EmailOption: false,
            VoteOption: true,
            SleepOption: true,
            appleMusicOption: false,

        }
    )

    const [mobileValue, setMobileValue] = useState("My Radio");
    const [displayForSinglePhoneScreen, setDisplayForSinglePhoneScreen] = useState([
        {
            id: "wf765fx76ui897", text: "My Radio", OtherContent: <MyRadioPhoneScreen />  //Here text is the streem name as shown in mobile phone top
        },
        { 
            id: "hkiw86g87t32fr575", text: "Facebook", OtherContent: <FacebookPhoneScreen /> 

        }, //Here text is the streem name as shown in mobile phone top 
        // 
        // when text is changed in mypagies then change text here also
        {
            id: "hwgtyu57666666666", text: "Blogs", OtherContent: <BlogPhoneScreen />
        },
        {
            id: "vhjwcg", text: "Alarm Clock", OtherContent: <AlarmPhoneScreen />
        },
        {
            id: "76ryt383", text: "Dedications", OtherContent: <DedicationPhoneScreen />
        },
        {
            id: "io9u8t", text: "Website", OtherContent: <WebsitePhoneScreen />
        },
        // {
        //     id: "ege87t789", text: "Website", OtherContent: <WebsitePhoneScreen />
        // },
        {
            id: "hu3489hsd", text: "RSS", OtherContent: <RSSPhoneScreen />
        },
        {
            id: "iuoweg", text: "HTML", OtherContent: <HtmlPhoneScreen />
        },
        {
            id: "iuy5o8", text: "Shout outs", OtherContent: <AudioShoutOutPhoneScreen />
        },
        {
            id: "0uu8it987", text: "Live feed", OtherContent: <LiveFeedPhoneScreen />
        },
        {
            id: "0y86ttguy", text: "Video", OtherContent: <VideoPhoneScreen />
        },
        {
            id: "jgwqdu", text: "Podcast", OtherContent: <PodcastPhoneScreen />
        },

    ])
    return (
        <MyMobileContext.Provider value={{
            displayForSinglePhoneScreen, setDisplayForSinglePhoneScreen, mobileValue, setMobileValue, allOptions, setAllOptions, preview, setPreview, previews, setPreviews, designChange, setDesignChange, MyBorderRef, MyLikeRef, sideBarToggleRef, toggleClass, setToggleClass, GeneralTextRef, MyBGColorChgRef, previewss, setPreviewss, dark, setDark, myTextColor, setMytextColor, myLanguage, setMyLanguage, MyBGColor, setMyBGColor, MyBGGradientColor, setMyBGGradientColor, selectedColorTextId, setSelectedColorTextId, bgOpacity, setBGOpacity, bgGradientOpacity, setBGgradientOpacity, BGGradientColorId, setBgGradientColorId, BGColorId, setBgColorId, value, setValue, blur, setBlur, blurCover, setBlurCover, font, setFont, backgroundType, setBackgroundType, BGColorTo, setBGColorTo, BGColorDirection, setBGColorDirection, BGBIColorDirection, setBGBIColorDirection,myRadioActive,setMyRadioActive,myRadioBorderOpacity,setMyRadioBorderOpacity,myRadioBorderColor,setMyRadioBorderColor,myRadioselectedColorId, setMyRadioSelectedColorId,myRadioArtistColor, setMyRadioArtistColor,myRadioSelectedBGColorId, setMyRadioSelectedBGColorId,myRadioSelectedColorTextId, setMyRadioSelectedColorTextId,myRadioBackgroundOpacity, setMyRadioBackgroundOpacity,myRadioBackgroundColor,setMyRadioBackgroundColor,myRadioTextColor,setMyRadiotextColor,myBorderRadious,setMyBorderRadious,textAndfont, setTextAndFont,buttonActive, setButtonActive,ShadowActive, setShadowActive,textAlignSetting, setTextAlignSetting,MyGeneralButtonColorId, setMyGeneralButtonColorId,myGeneralBTNColor,setMyGeneralBTNColor,myGeneralButtonOpacity,setMyGeneralButtonOpacity,BTNType,setBTNType,showPopup, setShowPopup,showLogoBorder,setShowLogoBorder,myMenuBGColor, setMyMenuBGColor,myMenuBGColorTextId, setMyMenuBGColorTextId,myMenuTextColor, setMyMenuTextColor,myMenuTextId, setMyMenuTextId,menuPreviews, setMenuPreviews,bodySize,setBodySize,myFacebookDesignColor,setMyFacebookDesignColor,myFacebookDesignColorId,setMyFacebookDesignColorId,myBlogDesignColorId,setMyBlogDesignColorId,myAlarmClockDesignColorId,setMyAlarmClockDesignColorId,myBlogDesignColor,setMyBlogDesignColor,myAlarmClockDesignColor,setMyAlarmClockDesignColor,myDedicationDesignColorId,setMyDedicationDesignColorId,myDedicationDesignColor,setMyDedicationDesignColor,myAudioShoutOutDesignColorId,setMyAudioShoutOutDesignColorId,myAudioShoutOutDesignColor,setMyAudioShoutOutDesignColor,mywbsiteDesignColorId,setMywbsiteDesignColorId,mywbsiteDesignColor,setMywbsiteDesignColor,myRSSDesignColorId,setMyRSSDesignColorId,myRSSDesignColor,setMyRSSDesignColor,myVideoDesignColorId,setMyVideoDesignColorId,myVideoDesignColor,setMyVideoDesignColor,myPodcastDesignColorId,setMyPodcastDesignColorId,myPodcastDesignColor,setMyPodcastDesignColor,myHTMLDesignColorId,setMyHTMLDesignColorId,myHTMLDesignColor,setMyHTMLDesignColor,appIconPreviews, setAppIconPreviews,smartPhoneLargePreviews, setSmartPhoneLargePreviews,smartPhonePreviews, setSmartPhonePreviews,appName,setAppName,shortDescription,setShortDescription,longDescription,setLongDescription,token,setToken,buttonValue,setButtonValue,allApps,setAllApps
        }}>
            {children}
        </MyMobileContext.Provider>
    )

}

